// Minted on first use rather than at module load: the SSR process keeps modules between requests,
// so a load-time id would be one id shared by every reader of every page. No event fires during
// SSR, so the server never mints one.
let twgTraceId: string | undefined;

export const getTwgTraceId = (): string => {
	if (twgTraceId === undefined) {
		twgTraceId = crypto.randomUUID();
	}
	return twgTraceId;
};

/** Test seam: forgets the id so each test starts from a fresh session. */
export const resetTwgTraceId = (): void => {
	twgTraceId = undefined;
};
